// import lib
import { lazy } from "react";

const routes = [
  {
    path: "/page_creation",
    element: lazy(() => import("../../pages/UserAccess/PageCreation/index")),
  },
  {
    path: "/page_creation/add",
    element: lazy(() => import("../../pages/UserAccess/PageCreation/create")),
  },
  {
    path: "/page_creation/edit/:id",
    element: lazy(() => import("../../pages/UserAccess/PageCreation/edit")),
  },
];

export default routes;
